import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';
const store = {
  namespaced: true,
  state: {
    listData: [],
    listCount: 0,
    pairs: [],
    pagination: {
      page: 1,
      size: 10
    }
  },
  mutations: {
    setList(state, payload) {
      state.listData = payload;
    },
    setListCount(state, payload) {
      state.listCount = payload;
    },
    setPairs(state, payload) {
      state.pairs = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  getters: {},
  actions: {
    getList({ commit }, quary) {
      api.getList(quary).then(({ data }) => {
        commit('setList', data.list);
        commit('setListCount', data.totalCount);
        commit('setPagination', { page: quary.page, size: quary.size })
      });
    },
    getPairs({ commit }) {
      api.getPairs().then(({ data }) => {
        commit('setPairs', data);
      });
    },
    addPairBonus({ commit }, form) {
      return new Promise(resolve => {
        api.addPairBonus(form).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('pairBonus', store);
